import React from 'react';
import { RoutingStep } from '../../../../../../../../../../../../models/Routes';
import WorkflowAcceptPage from './pages/WorkflowAcceptPage';
import WorkflowConfirmPage from './pages/WorkflowConfirmPage';
import WorkflowEnquirePage from './pages/WorkflowEnquirePage';
import WorkflowOfferPage from './pages/WorkflowOfferPage';
import { Navigate } from 'react-router-dom';
import useMatchMedia from 'hooks/useMatchMedia';

// Mobile lands on the stage list, so only desktop preselects a stage.
const WorkflowIndexRedirect: React.FC = () => {
  const isAbovePhablet = useMatchMedia('isAbovePhablet');

  return isAbovePhablet ? <Navigate to="enquire" replace /> : null;
};

export default [
  {
    path: 'enquire',
    element: WorkflowEnquirePage,
    labelId: 'enquire',
    stepName: 'enquire',
  },
  {
    path: 'accept',
    element: WorkflowAcceptPage,
    labelId: 'accept',
    stepName: 'accept',
  },
  {
    path: 'confirm',
    element: WorkflowConfirmPage,
    labelId: 'confirm',
    stepName: 'confirm',
  },
  {
    path: 'offer',
    element: WorkflowOfferPage,
    labelId: 'offer',
    stepName: 'offer',
  },
  {
    index: true,
    element: WorkflowIndexRedirect,
  },
] as Array<RoutingStep>;
